/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePosOrderInput = {|
  ccOwner: string,
  ccType: string,
  company?: ?string,
  email: string,
  firstname: string,
  lastname: string,
  operator: string,
  paymentMethod: string,
  phoneNumber: string,
  storeId: string,
  tyroData: InputTyro,
|};
export type InputTyro = {|
  card?: ?InputTyroCard,
  sessionId?: ?string,
  transactionId?: ?string,
|};
export type InputTyroCard = {|
  brand?: ?string,
  month?: ?string,
  number?: ?string,
  year?: ?string,
|};
export type CreatePosOrderMutationVariables = {|
  input: CreatePosOrderInput
|};
export type CreatePosOrderMutationResponse = {|
  +createPosOrder: ?{|
    +cartId: ?string,
    +result: ?any,
  |}
|};
export type CreatePosOrderMutation = {|
  variables: CreatePosOrderMutationVariables,
  response: CreatePosOrderMutationResponse,
|};
*/


/*
mutation CreatePosOrderMutation(
  $input: CreatePosOrderInput!
) {
  createPosOrder(input: $input) {
    cartId
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreatePosOrderPayload",
    "kind": "LinkedField",
    "name": "createPosOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cartId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePosOrderMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatePosOrderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a822f40ec48b0a17ba6f2e64932a9cdb",
    "id": null,
    "metadata": {},
    "name": "CreatePosOrderMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePosOrderMutation(\n  $input: CreatePosOrderInput!\n) {\n  createPosOrder(input: $input) {\n    cartId\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cb31ddc7cb492ee59281ba04feb61184';

module.exports = node;
